import { render, staticRenderFns } from "./CoBreadcrumbs.vue?vue&type=template&id=4acf1a14&scoped=true&"
import script from "./CoBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./CoBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./CoBreadcrumbs.vue?vue&type=style&index=0&id=4acf1a14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf1a14",
  null
  
)

export default component.exports